import { createHighlightComponent } from 'instantsearch-ui-components';
import { createElement, Fragment } from 'preact';

var InternalHighlight = createHighlightComponent({
    createElement: createElement,
    Fragment: Fragment
});

export { InternalHighlight };
